<template>
    <div class="account-menu-wrapper" :class="{ active: menuOpen }">
        <profile-image v-show="menuOpen" />
        <transition name="slide-fade">
            <div
                class="menu-container"
                :class="{ expanded: isMenuExpanded }"
                v-show="menuOpen"
            >
                <dynamic-link :type="currentMenuComponent" />
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileImage from "./profile-image.vue";
import DynamicLink from "./dynamic-link.vue";
import Mixins from "../../mixins/mixins";
import { SCREEN_NAMES_ANALYITICS } from "../../config";

export default {
    props: ["menuOpen"],
    mixins: [Mixins],
    components: {
        ProfileImage,
        DynamicLink,
    },
    computed: {
        ...mapGetters({
            currentMenuContentPage: "menu/currentMenuContentPage",
            currentMenuComponent: "menu/currentMenuComponent",
            isMenuExpanded: "menu/isMenuExpanded",
        }),
    },
    methods: {
        closeMenu() {
            this.$store.commit({
                type: "menu/setMenuOpen",
                menuOpen: false,
            });
        },
        isMenuContentPage(name) {
            return this.currentMenuContentPage == name;
        },
    },
    watch: {
        menuOpen(value) {
            if (value) {
                this.$store.commit({
                    type: "menu/setCurrentMenuItem",
                    item: {
                        menuContent: "main-menu",
                        component: "main-menu/main-menu.vue",
                        isMenuExpanded: false,
                    },
                });
                this.setScreenNameForAnalytics(
                    SCREEN_NAMES_ANALYITICS.PROFILE[this.currentMenuContentPage]
                );
            } else {
                this.setScreenNameToLastRoute();
            }
        },
        currentMenuContentPage(value) {
            if (value)
                this.setScreenNameForAnalytics(
                    SCREEN_NAMES_ANALYITICS.PROFILE[value]
                );
        },
    },
};
</script>
